import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { RcsbView } from "./SequenceViews/RcsbView/RcsbView";
export class RcsbFvSequence extends React.Component {
    render() {
        const config = this.props.config;
        return (_jsx(RcsbView, Object.assign({}, config, { componentId: this.props.componentId, stateManager: this.props.stateManager, title: this.props.title, subtitle: this.props.subtitle, unmount: this.props.unmount, rcsbViewBehaviour: this.props.rcsbViewBehaviour })));
    }
}
